/**
 * Configuracao runtime do frontend.
 *
 * Em desenvolvimento, deixe VITE_API_BASE_URL vazio para usar o proxy do Vite
 * (configurado em vite.config.ts) - assim "/api/..." e "/health" sao
 * repassados para o backend definido em VITE_API_PROXY_TARGET.
 *
 * Em producao, defina VITE_API_BASE_URL para a origem do backend
 * (ex: "https://api.exemplo.com").
 */
export const config = {
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL ?? "").replace(/\/+$/, ""),
} as const;

export function apiUrl(path: string): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${config.apiBaseUrl}${p}`;
}
